<template>
  <Modal
    data-test="modal__container"
    class="dea-modal-overlay--video dea-modal--no-footer"
    :visible="visible"
    @modalClose="$emit('close-modal')"
  >
    <template slot="title">Scopri come funziona la tua Area Personale:</template>
    <template slot="content">
      <div class="video-modal__player-container" data-test="modal__launch-video">
        <iframe id="ytplayer" class="video-modal__player" :src="videoUrl" frameborder="0" allowfullscreen />
      </div>
    </template>
    <template slot="footer"></template>
  </Modal>
</template>

<script>
import Modal from "@/components/patterns/Modal";

export default {
  name: "VideoModal",
  components: { Modal },
  props: {
    user: {
      type: Object,
      required: true,
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    videoUrl() {
      if (this.user.teacher) return this.$root.config.videoLaunch.teacher;
      if (this.user.student) return this.$root.config.videoLaunch.student;
      if (this.user.parent) return this.$root.config.videoLaunch.parent;
      return "";
    },
  },
};
</script>

<style lang="scss">
@import "~deascuola-storybook/src/styles/system.utils";

.dea-modal-overlay--video {
  .dea-modal {
    max-height: 90vh;
    overflow-y: auto;
  }
}

.video-modal__player-container {
  @include media("<=m") {
    height: auto;
    width: 90vw;
  }

  margin-bottom: $dea-size-large;
  overflow: hidden;
  padding-top: 56.25%; // See https://blog.theodo.com/2018/01/responsive-iframes-css-trick/
  position: relative;

  .video-modal__player {
    border: 0;
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
  }
}
</style>
